import { makeAutoObservable } from 'mobx';
import { ISaveable } from '../../../../../stores/types';
import { ICredentialsStore } from '../integration-store';

export interface IShipheroCredentials {
    refresh_token: string,
}

class ShipheroCredentialsStore implements ISaveable, ICredentialsStore {
    private _changes: IShipheroCredentials = {} as IShipheroCredentials;

    constructor() {
        makeAutoObservable(this);
    }

    public get refresh_token() { return this._changes.refresh_token; }

    public set refresh_token(v: string) { this._changes.refresh_token = v; }

    /** ICredentialsStore implementation ************/
    public async getCredentials() {
        return { ...this._changes };
    }


    /********* ISaveable implementation *************/
    public hasChanges(): boolean {
        return !!Object.keys(this._changes).length;
    }

    public discardChanges(): void {
        this._changes = {} as IShipheroCredentials;
    }

    public getUpdatedModel(): IShipheroCredentials { throw new Error('Not implemented.'); }
    public isSaving(): boolean { throw new Error('Not implemented.'); }
    public commitChanges() { throw new Error('Not implemented.'); }
    public async save() { throw new Error('Not implemented.'); }
}

export default ShipheroCredentialsStore;
